
export default {
  name: "Breadcrumb",
  data() {
    return {
      treeList: [],
      menuList: [],

      currentPath: null,
    };
  },
  props: {
    customList: {
      type: Array,
      default() {
        return [];
      },
    },
    navType: {
      type: Number,
      default: 1,
    },
  },
  created() {
    let strList = "";
    if (this.$route.path.endsWith("/")) {
      const pathList = this.$route.path.split("/");
      pathList.pop();
      strList = pathList;
    } else {
      strList = this.$route.path.split("/");
    }
    if (!this.$route.path.includes("/page-")) {
      this.currentPath = `/${strList[strList.length - 1]}`;
    } else {
      this.currentPath = `/${strList[strList.length - 2]}`;
    }
    if (this.customList.length > 0) {
      this.menuList = JSON.parse(JSON.stringify(this.customList));
      return;
    }
    this.treeList = JSON.parse(
      JSON.stringify(this.$store.state.headerData.menu),
    );
    if (this.navType == 1) {
      let nodeId = this.getParentNodeId(this.treeList, this.$route.path);
      this.menuList = this.getParentList(this.treeList, nodeId);
    } else {
      let pathList = this.$route.path.split("/");
      pathList.forEach((v, i) => {
        if (v) {
          let name = v.slice(0, 1).toUpperCase() + v.slice(1);
          this.menuList.push({
            name_ch: name,
            path: "/" + v,
          });
        }
      });
    }
  },
  methods: {
    getParentNodeId(tree, path) {
      for (let node of tree) {
        if (node.path == path) return node.ID;
        if (node.children && node.children.some(child => child.path === path)) {
          return node.ID;
        }
        if (node.children) {
          const parentId = this.getParentNodeId(node.children, path);
          if (parentId !== null) {
            return parentId;
          }
        }
      }
      return null;
    },
    getParentList(tree, id) {
      let temp = [];
      let forFn = function (arr, id) {
        for (let i = 0; i < arr.length; i++) {
          let item = arr[i];
          if (item.isDefault) {
            if (item.ID === id) {
              temp.push(item);
              if (item.children.length > 0) {
                forFn(item.children, id);
              }
              break;
            }
          } else {
            // if (item.parentid === id) {
            //   temp.push(item);
            //   break;
            // }
          }
          if (item.children.length > 0) {
            forFn(item.children, id);
          }
        }
      };
      forFn(tree, id);
      return temp;
    },
    handleShowLine(index) {
      if (index + 1 < this.menuList.length) {
        return true;
      }
      return false;
    },
  },
};
